import { breadcrumbJsonLd } from "@amtana/browser";
import type { SeoJsonLdBlock } from "@amtana/browser";
import { pathWithLanguage } from "@amtana/i18n";
import type { Language } from "@amtana/i18n";
import { shippedLanguage } from "@amtana/i18n/catalog";

import { SITE_URL } from "./model/site-url.ts";

/** A family page's `BreadcrumbList` in `language`, from English paths (ADR-034 point 7). */
export function familyBreadcrumb(
  language: Language,
  items: ReadonlyArray<{ readonly name: string; readonly path: string }>,
): SeoJsonLdBlock {
  return breadcrumbJsonLd({
    siteUrl: SITE_URL,
    items: items.map((item) => ({
      name: item.name,
      path: pathWithLanguage(item.path, shippedLanguage(language)),
    })),
  });
}
